var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-card',[_c('v-container',[_c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('h4',{staticClass:"text-center"},[_vm._v(" "+_vm._s(_vm.$t('register_line'))+" ")])])],1),_c('v-row',[_c('appointment-form')],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }